angular.module('impactx.productgroup').controller('ProductGroupsEditCtrl', [
    '$scope',
    '$routeParams',
    'dataGen',
    '$mdToast',
    'BackService',
    '$mdDialog',
    'CommentOnSaveService',
    'ToastService',
    '$config',
    'ConfirmationService',
    'TranslationService',
    'ToolbarService',
    'DownloadService',
    ProductGroupsEditCtrl
]);

function ProductGroupsEditCtrl($scope, $routeParams, dataGen, $mdToast, BackService, $mdDialog, CommentOnSaveService, ToastService, $config, ConfirmationService,
                         TranslationService, ToolbarService, DownloadService) {
    var ctrl = this;
    var openPrgIds = [];
    dataGen.getData($scope, {catId: $routeParams.catId, vcatId: $routeParams.vcatId}, "/productgroup/root").then(function () {
        defineButtons();
    });

    this.save = function () {
        dataGen.postAsForm($scope, {data: $scope.data}, "/productgroup/save").then(function () {
            BackService.back();
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
    })};

    this.toggle = function (event, entry) {
        event.stopPropagation();
        event.preventDefault();
        if (entry.isOpen) {
            var index = openPrgIds.indexOf(entry.id);
            if (index >= 0) {
                openPrgIds.splice(index, 1);
            }
        }
        else {
            if (!entry.priceRuleDataOfSubGroupsSet) {
                ctrl.getPriceRuleDataForSubGroups(entry)
            }
            openPrgIds.push(entry.id);
        }
        entry.isOpen = !entry.isOpen;
    };

    this.editEntry = function (event, entry) {
        event.stopPropagation();
        event.preventDefault();
        ctrl.edit(event, entry);
    };

    this.editPriceEntry = function (event, entry) {
        event.stopPropagation();
        event.preventDefault();
        ctrl.editPrice(event, entry);
    };

    this.deleteEntry = function (event, entry) {
        event.stopPropagation();
        event.preventDefault();
        ctrl.deleteProductGroup(event, entry);
    };

    this.addEntry = function (event, entry) {
        event.stopPropagation();
        event.preventDefault();
        ctrl.edit(event, null, entry);
    };

    this.edit = function (event, entry, superEntry) {
        $mdDialog.show({
            templateUrl: 'modules/productgroup/templates/product-group-edit.dialog.tmpl.html',
            controller: "ProductGroupEditDialogCtrl",
            controllerAs: "productGroupEditDialogCtrl",
            targetEvent: event,
            locals: {
                catId: $routeParams.catId,
                vcatId: $routeParams.vcatId,
                prgId: entry ? entry.id : 0,
                superPrgId: superEntry ? superEntry.id : 0
            },
            bindToController: true,
            clickOutsideToClose: false
        }).then(ctrl.reloadData, angular.noop);
    }

    this.editPrice = function (event, entry) {
        $mdDialog.show({
            templateUrl: 'modules/productgroup/templates/product-group-edit-price.dialog.tmpl.html',
            controller: "ProductGroupEditPriceDialogCtrl",
            controllerAs: "productGroupEditPriceDialogCtrl",
            targetEvent: event,
            locals: {
                catId: $routeParams.catId,
                vcatId: $routeParams.vcatId,
                prgId: entry ? entry.id : 0
            },
            bindToController: true,
            clickOutsideToClose: false
        }).then(ctrl.reloadData, angular.noop);
    }

    this.deleteProductGroup = function (event, entry) {
        $mdDialog.show({
            templateUrl: 'modules/productgroup/templates/product-group-delete.dialog.tmpl.html',
            controller: "ProductGroupDeleteDialogCtrl",
            controllerAs: "productGroupDeleteDialogCtrl",
            targetEvent: event,
            locals: {
                catId: $routeParams.catId,
                vcatId: $routeParams.vcatId,
                prgId: entry ? entry.id : 0,
                deleteSetting: JSON.parse(JSON.stringify($scope.data.deleteSetting)),
                deleteQuestion: $scope.trns.deleteQuestion,
                superPrgId: entry ? entry.superPrgId : 0
            },
            bindToController: true,
            clickOutsideToClose: false
        }).then(ctrl.reloadData, angular.noop);
    }

    this.reloadData = function () {
        dataGen.getData($scope, {catId: $routeParams.catId, vcatId: $routeParams.vcatId}, "/productgroup/root").then(function () {
            for (var i = 0; i < $scope.data.productGroups.length; i++) {
                var productGroup = $scope.data.productGroups[i];
                if (openPrgIds.indexOf(productGroup.id) >= 0) {
                    productGroup.isOpen = true;
                    if (!productGroup.priceRuleDataOfSubGroupsSet) {
                        ctrl.getPriceRuleDataForSubGroups(productGroup);
                    }
                }
                ctrl.openSubGroups(productGroup);
            }
        });
    }

    this.openSubGroups = function (productGroup) {
        for (var i = 0; i < productGroup.subProductGroups.length; i++) {
            var subGroup = productGroup.subProductGroups[i];
            if (openPrgIds.indexOf(subGroup.id) >= 0) {
                subGroup.isOpen = true;
                if (!subGroup.priceRuleDataOfSubGroupsSet) {
                    ctrl.getPriceRuleDataForSubGroups(subGroup);
                }
            }
            ctrl.openSubGroups(subGroup);
        }
    }

    this.getPriceRuleDataForSubGroups = function (entry) {
        var subGroups = [];
        for (var i = 0; i < entry.subProductGroups.length; i++) {
            subGroups.push({id: entry.subProductGroups[i].id});
        }
        dataGen.postAsForm({}, {catId: $routeParams.catId, vcatId: $routeParams.vcatId, productGroups: subGroups}, "/productgroup/pricerule").then(function (data) {
            entry.priceRuleDataOfSubGroupsSet = true;
            for (var i = 0; i < entry.subProductGroups.length; i++) {
                entry.subProductGroups[i].priceRuleData = data.data.productGroups[i].priceRuleData;
            }
        });
    }

    this.exportArticleSheet = function (event, entry) {
        DownloadService.openDownloadPost('/productgroup/exportArticleSheet', {paramName: "id", paramValue: (entry ? entry.id : 0)})
    };

    function defineButtons() {
        ToolbarService.setButtons([]);
    }

}